module.exports = __webpack_public_path__ + "img/popup_title5.4f2a13ef.png";